import(/* webpackMode: "eager" */ "/codebuild/output/src3631144748/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/page.tsx");
